<template>
    <div id="app">
        <div id="animations">
        </div>
        <!-- <canvas id="canvas"></canvas> -->
        <transition name="fade">
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'App',
    data() {
        return {
            load: true,
            toggleStatus: 0,
            dimension: 25,
            color: "#ffffff"
        }
    },
    computed: {
        currentArtwork() {
            return this.$store.state.currentArtwork;
        },
    },
    components: {},
    mounted() {
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', 'https://code.jquery.com/pep/0.4.3/pep.js')
        document.head.appendChild(externalScript)


        

    },
    methods: {

    },
    watch: {
        currentArtwork(n, o) {
            if (n && n != 0) {
                console.log(n);
            }
        }
    }
}
</script>